import React from 'react';
const Loader = () => {
	return (
		<div className="cmgf-loader">
			<div className="cmgf-loader__spin"></div>
		</div>
	);
};

export default Loader;
